import React from "react";
import "./MainSection.css";
import featureImage from "../assets/feature-image.png";
import featureImageTwo from "../assets/feature-image2.png";
import featureImageThree from "../assets/feature-image3.png";
import featureImageFour from "../assets/feature-image4.png";
import appIcon from "../assets/app-icon.png";
import Footer from "./Footer.js";

const EnglishSection = () => {
    return (
        <>
        <div className="logo">
        <img src={appIcon} alt="App Icon" className="app-icon" />
        </div>
        <main className="main-section">
            <div className="content">
              <a
                className="download-btn"
                href="https://play.google.com/store/apps/details?id=com.maquickscanner"
                download
              >
                Download APK
              </a>
            </div>
          </main>
    
          <div className="description-paragraph">
            <p>
                The <strong>MA Quick Scanner</strong> simplifies lottery ticket management for retailers with features like fast QR code scanning, manual ticket entry, booklet sales, and detailed sales reports. Designed for approved retailers, it ensures accuracy, efficiency, and security, enhancing operational performance and business growth.
            </p>
          </div>
    
          <div className="features-container">
            {[{
              image: featureImage,
              title: "Ticket Management",
              description: "Efficiently manage and sell lottery tickets with the MA Quick Scanner App. This versatile app allows you to scan tickets, manually enter details, or sell by booklet, all while organizing tickets by draw dates for quick and easy access. Designed to streamline operations, the app ensures accuracy and efficiency, making it an essential asset for retailers."
            }, {
              image: featureImageTwo,
              title: "Scan History",
              description: "Effortlessly track and manage ticket details with the MA Quick Scanner App's Scan History feature. This allows you to instantly remove any incorrect sales using delete scan history feature, ensuring flawless record-keeping and maintaining the accuracy of your sales data."
            }, {
              image: featureImageThree,
              title: "Reports",
              description: "MA Quick Scanner App generates detailed reports, including statement, purchase, return, unsold, and prize-winning ticket (PWT). You can download these reports as PDFs for better decision-making and efficient lottery management, ensuring accurate records and optimized business strategies."
            }, {
              image: featureImageFour,
              title: "Lottery Results",
              description: "The MA Quick Scanner App provides rapid access to lottery results, conveniently organized into 'Today' and 'History' tabs for effortless viewing. This feature ensures that you can quickly check the latest results as well as review past outcomes, making it easy to stay updated and manage your lottery activities efficiently."
            }].map((feature, index) => (
              <section key={index} className={`feature-item ${index % 2 !== 0 ? 'reverse' : ''}`}>
                <div className="feature-image">
                  <img src={feature.image} alt="App Features Screenshot" />
                </div>
                <div className="feature-content">
                  <h2>{feature.title}</h2>
                  <p>{feature.description}</p>
                </div>
              </section>
            ))}
          </div>
    
          <section className="how-to-use-section">
            <h1>How to Use</h1>
            <div className="how-to-use-steps">
              <ol>
                <li>
                  <strong>Download & Install:</strong> Click the "Download Button" to install the app in Google Play Store.
                </li>
                <li>
                  <strong>Open the App:</strong> Once installed, Registered Retailers can Login by OTP Based Authentication.
                </li>
                <li>
                  <strong>Start Scanning:</strong> Click the scan icon to scan lottery tickets and instantly update your inventory in the scan history screen.
                </li>
                <li>
                  <strong>Track Your Tickets:</strong> View sold and unsold tickets, access reports in reports screen, and stay updated with real-time data.
                </li>
                <li>
                  <strong>View Results:</strong> Quickly check lottery results in a simple and user-friendly interface.
                </li>
                <li>
                  <strong>Generate Reports:</strong> Use the reporting feature to analyze trends and improve your lottery sales strategy.
                </li>
              </ol>
            </div>
            <div className="video-container">
            <h3>Quick Product Walkthrough</h3>
            <video 
              controls 
              width="100%" 
              className="how-to-video"
              poster="https://maquickscannerappwebsite.blob.core.windows.net/maquickscannerwebpage-container/video-thumbnail.png?sp=r&st=2025-02-13T06:15:45Z&se=2030-02-13T14:15:45Z&sv=2022-11-02&sr=b&sig=W9ajKx8pfss1GIwshQ7v4DKEbpuXi8armkNTU6w4Il8%3D"
            >
            <source
             src="https://maquickscannerappwebsite.blob.core.windows.net/maquickscannerwebpage-container/MA_Quick_Scanner.mp4?sp=r&st=2025-02-11T14:11:00Z&se=2030-02-11T22:11:00Z&sv=2022-11-02&sr=b&sig=mpDitj8BzJboaN43HKtDzDcEizupqwwHkjob23%2F8zQ8%3D"
             type="video/mp4"
            />
             Your browser does not support the video tag.
            </video>
            </div>
          </section>
          <Footer/>
        </>
      );
}
export default EnglishSection;